import React from "react";
import "../css/styles.css";
import { SpeciesCounts } from "./SpeciesCounts";
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';

export class Scroller extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      speciesName: this.props.speciesName,
      boatScores: this.props.boatScores,
      boatClass: this.props.boatClass,
      classBoats: [],
      tiles: this.props.tiles
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({boatScores: newProps.boatScores, rowWidth: newProps.rowWidth, tiles: newProps.tiles, boatClass: newProps.boatClass});
    this.classFilter();
  }
    
  classFilter() {
    console.log('Boat Scores: ', this.props.boatScores)
      var scores = this.props.boatScores;
      var boatClass = this.props.boatClass;
      var classBoats = [];
      scores.forEach((boat) => {
          if(boat.boat.boatClass === boatClass && boat.boat.total > 0) {
              var lastF = this.getLastFishTime(boat.boat.speciesCounts);
              classBoats.push({
                  id: boat.boat.id,
                  boatClass: boat.boat.boatClass,
                  boatName: boat.boat.boatName,
                  boatThm: boat.boat.boatThm,
                  speciesCounts: boat.boat.speciesCounts,
                  lastFishTime: boat.boat.lastFishTime,
                  lastSpeceiesFishTime: lastF[0],
                  total: boat.boat.total
              });
          }
      })
      this.scoreSortFilter(classBoats);
  }
    
  getLastFishTime(times){
      var timesArray = [];
      times.forEach((time) => {
          if(time.speciesTimes){
              time.speciesTimes.forEach((t) => {
                  var secs = new Date(t).getTime() / 1000;
                  timesArray.push(secs);
              })
          }
      })
      timesArray.sort((a, b) => b - a);
      
      return timesArray;
  }
    
  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    boatScores.sortOn("total", "lastSpeceiesFishTime");
    boatScores.reverse();
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })

    this.setState({
        classBoats: bScores
    })
  }
  
render() {
    return (
      <div className="speciesScoresBoxPelagicQueposDesk"> 
        <div className="division_titleDT"> Billfish Division</div>
          <div id='rank-box' className="boatBox" style={{width: '100%'}}>
            <div className='speciesTotalRow'>
              <div className='speciesRankBox'></div>
              <div className='boatNameBox'>Boat Name</div>
              <div className='speciesCountsBox'>
                <div className='speciesBox'>S</div>
                <div className='speciesBox'>BM</div>
                <div className='speciesBox'>SM</div>
                <div className='speciesBox'>BLM</div>
              </div>
              <div className='ptsBox'>Pts</div>
            </div>
          </div>
          {this.props.boatScores.length > 0 ?  this.props.boatScores.map(boat => (
            <div id='rank-box' className="boatBox" style={{width: '100%'}} key={boat.boat.id}>
              <div className='speciesTotalRow'>
               <div className='speciesRankBox'># {boat.rank}</div>
               <div className='boatNameBox'>{boat.boat.boatName}</div>
               <SpeciesCounts speciesCounts={boat.boat.speciesCounts}/>
               <div className='ptsBox'>{boat.boat.total}</div>
             </div>
            </div>
          )) : <div style={{color: '#fff', fontSize: 24}}>No fish logged yet.</div> }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/pescadora/comps/Scroller.js